import { Component, inject } from '@angular/core';

import { CookieService } from '~features/cookies/cookie.service';

@Component({
  selector: 'app-cookie-toast',
  imports: [],
  templateUrl: './cookie-toast.component.html',
  styleUrl: './cookie-toast.component.css',
})
export class CookieToastComponent {
  cookieService = inject(CookieService);

  acceptCookies() {
    this.cookieService.setFullCookiePermissions();
  }

  denyCookies() {
    this.cookieService.setAnonymousCookiePermissions();
  }
}
